<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por um cliente" v-model="searchText"
                      style="max-width: 400px"
                      class="rounded-card"
        :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
    </px-line-filter>
  </div>
</template>

<script>
export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  data() {
    return {
      statusOptions: [
        {
          id: 'NAO_RESPONDIDA',
          description: 'Não respondidas',
          value: ['NAO_RESPONDIDA'],
        },
        {
          id: 'RESPONDIDA',
          description: 'Respondidas',
          value: ['RESPONDIDA'],
        },
        {
          id: 'RECUSADAS',
          description: 'Recusadas',
          value: [
            'SEM_ESTOQUE',
            'NAO_POSSUI_ESPECIFICACAO',
            'NAO_FORNECE',
            'NAO_ENTREGA_LOCAL',
          ],
        },
      ],
    };
  },
  computed: {
    selectedStatus: {
      get() {
        return this.$store.getters['listagemCotacao/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemCotacao/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemCotacao/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemCotacao/searchText', searchText);
      },
    },
  },
  created() {
    if (!this.selectedStatus) {
      [this.selectedStatus] = this.statusOptions;
    }
  },
};
</script>
